import axios from 'axios';

import { env } from 'config';
import {
  PaginatedData,
  PayoutManualBatch,
  PayoutOrder,
  QueryParams,
} from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/payout-orders/manual`;

const getQueuePaginated = async (
  params: QueryParams,
): Promise<PaginatedData<PayoutOrder>> =>
  (await apiUtils.getWithQueryParams(`${url}/orders`, params)).data;

// Both return as soon as the batch opens — the orders are sent in the background.
const assign = async (payload: {
  orderIds: string[];
  providerId: string;
}): Promise<PayoutManualBatch> =>
  (await axios.post(`${url}/assign`, payload)).data;

const cancel = async (payload: {
  orderIds: string[];
}): Promise<PayoutManualBatch> =>
  (await axios.post(`${url}/cancel`, payload)).data;

const getBatchesPaginated = async (
  params: QueryParams,
): Promise<PaginatedData<PayoutManualBatch>> =>
  (await apiUtils.getWithQueryParams(`${url}/batches`, params)).data;

const getBatch = async (id: string): Promise<PayoutManualBatch> =>
  (await axios.get(`${url}/batches/${id}`)).data;

const getOrderBatches = async (orderId: string): Promise<PayoutManualBatch[]> =>
  (await axios.get(`${url}/orders/${orderId}/batches`)).data;

export const payoutManualApi = {
  getQueuePaginated,
  assign,
  cancel,
  getBatchesPaginated,
  getBatch,
  getOrderBatches,
};
